<template>
    <div class="relative">
        <div class="">
            <ssr-carousel class="hidden sm:block" paginate-by-slide :slides-per-page='4' :gutter='20' :autoplay-delay="6">
                <div v-for="curriculum in curriculums" :key="curriculum.id">
                    <a href="/curricula" class="focus-none">
                        <div class="text-white border-2 border-gray-200 rounded-md shadow-lg slide">
                            <div class="flex justify-center p-4">
                                <img :src="`${curriculum.icon}`" class="w-20 h-20 rounded-t-md">
                            </div>
                            <div class="flex flex-col px-1 sm:p-4 cust-height">
                                <h4 class="my-3 text-sm font-bold uppercase sm:text-lg">{{ $t(curriculum.title) }}</h4>
                                <p class="text-base text-justify">
                                    {{ curriculum.description | truncate(180, '...') }}
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
            </ssr-carousel>
            <ssr-carousel class="block sm:hidden" paginate-by-slide :slides-per-page='1' :gutter='10' :show-dots="true" :autoplay-delay="6">
                <div v-for="curriculum in curriculums" :key="curriculum.id">
                    <a href="#" class="focus-none">
                        <div class="px-4 py-2 text-white border-2 border-gray-200 rounded-md shadow-lg slide">
                            <div class="flex justify-center p-4">
                                <img :src="`${curriculum.icon}`" class="h-36 w-36 rounded-t-md">
                            </div>
                            <div class="flex flex-col px-1 py-2 sm:p-4 cust-height-small">
                                <h4 class="my-3 text-lg font-bold uppercase">{{ $t(curriculum.title) }}</h4>
                                <p class="justify-center text-sm">
                                    {{ curriculum.description | truncate(160, '...') }}
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
            </ssr-carousel>
        </div>
    </div>
</template>
 
<script>
    import SsrCarousel from 'vue-ssr-carousel'
    import ssrCarouselCss from 'vue-ssr-carousel/index.css'

    export default {
        props: ['curriculums'],
        components: { SsrCarousel},
        filters: {
            truncate: function(text, length, clamp){
                clamp = clamp || '...';
                var node = document.createElement('div');
                node.innerHTML = text;
                var content = node.textContent;
                return content.length > length ? content.slice(0, length) + clamp : content;
            }
        },
    }
</script>
<style scoped>
    .cust-height{
        min-height: 16rem;
    }
    .cust-height-small{
        min-height: 9.5rem;
    }
</style>